import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, SxProps,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';
import ConfirmDialogProps from './ConfirmDialogProps';

const sizeSx: SxProps<Theme> = {
  height: (theme) => theme.spacing(4.5),
  textTransform: 'capitalize',
};
const primarySx: SxProps<Theme> = {
  backgroundColor: 'primary.main',
  color: 'common.white',
  '&:hover': {
    backgroundColor: 'primary.light',
  },
};
const secondarySx: SxProps<Theme> = {
  backgroundColor: 'secondary.main',
  color: 'common.white',
  '&:hover': {
    backgroundColor: 'secondary.light',
  },
};

const ConfirmDialog: React.FC<React.PropsWithChildren<ConfirmDialogProps>> = (props) => {
  const {
    open, leftButton, rightButton, data, content, title,
  } = props;

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          minWidth: (theme) => theme.spacing(40),
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {
          leftButton && (
          <Button
            color="secondary"
            size="medium"
            onClick={(e) => leftButton.onClick(e, data)}
            sx={
              [sizeSx, secondarySx]
            }
            variant="contained"
          >
            {leftButton.label}
          </Button>
          )
        }
        {
          rightButton && (
          <Button
            color="primary"
            size="medium"
            onClick={(e) => rightButton.onClick(e, data)}
            sx={
              [sizeSx, primarySx]
            }
            variant="contained"
          >
            {rightButton.label}
          </Button>
          )
        }
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
